<template>
  <t-default-layout
    v-bind="$store.state.user"
    :current-user-info="currentUserInfo"
    :handle-online-status-change="handleOnlineStatusChange"
    :handle-logout="handleLogout"
    :notice-list="noticeList"
  >
    <router-view
      v-bind="$store.state.user"
      :current-user-info="currentUserInfo"
      :notice-list="noticeList"
      :set-loading="setLoading"
      :show-info-modal="showInfoModal"
      :show-error-modal="showErrorModal"
    ></router-view>
    <o-modal
      id="index_resultModal"
      v-model:visible="resultModalVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      z-index="9998"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>{{ resultModalTitle }}</template>
      <a-text>
        <!-- eslint-disable -->
        <span v-html="resultModalContent" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button variant="block" color="primary" label="OK" size="small" @click="handleCloseModal" />
      </template>
    </o-modal>
    <loading :active="isLoading" :is-full-page="true" :height="100" :width="100"></loading>
  </t-default-layout>
</template>

<script>
import TDefaultLayout from '@/components/templates/default-layout/index-service-termination.vue';
import { customRequest } from '@/common/customRequest.js';
import { mapActions } from 'vuex';
import { messageContent } from '@/common/messageContent.js';
import { customValidate } from '@/common/customValidate.js';
import { utils } from '@/common/utils.js';
import Loading from 'vue-loading-overlay';
export default {
  name: 't-index-service-termination',
  components: { TDefaultLayout, Loading },
  mixins: [customRequest, customValidate, utils],
  data: function () {
    return {
      //Modal
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      // logged-out status
      isLoggedOut: false,
      // 通知インスタンス
      notificationInstance: {
        sessionAboutToExpire: null,
      },
      // 通知のON／OFF設定
      notificationFlag: null,
      // セッションの有効期限切れる警告
      sessionAboutToExpire: false,
      // loadingモーダル
      isLoading: false,
    };
  },
  computed: {
    onlineStatus() {
      return this.$store.state.onlineStatus;
    },
    businessHour() {
      return this.$store.state.businessHour;
    },
    clientName() {
      return this.$store.state.user.clientName;
    },
    companyID() {
      return this.$store.state.user.companyID;
    },
    userID() {
      return this.$store.state.user.userID;
    },
    currentUserInfo() {
      return {
        online: this.$store.state.onlineStatus ? true : false,
        business_hour: this.$store.state.businessHour,
        name: this.$store.state.user.username ? this.$store.state.user.username : '',
        company_id: this.$store.state.user.companyID ? this.$store.state.user.companyID : '',
        phone_number: this.$store.state.user.phoneNumber ? this.$store.state.user.phoneNumber : '',
        auth_info: this.$store.state.user.authInfo ? this.$store.state.user.authInfo : '',
        edit_profile_url: '#1',
        logout_url: '#2',
        clientName: this.$store.state.user.clientName ? this.$store.state.user.clientName : '',
      };
    },
  },
  watch: {
    sessionAboutToExpire(val) {
      if (val) {
        this.checkNotificationPermission()
          .then(result => {
            if (result === 'granted') {
              if (this.notificationFlag === true) {
                this.notificationInstance.sessionAboutToExpire = new Notification('COTOHA Call Center', {
                  body: messageContent.sessionAboutToExpireWarning,
                });
                this.notificationInstance.sessionAboutToExpire.onclick = event => {
                  event.preventDefault();
                  window.focus();
                  this.notificationInstance.sessionAboutToExpire.close();
                };
              }
            }
          })
          .catch(() => {});
      }
    },
  },
  created() {},
  async mounted() {
    setInterval(this.sessionAboutToExpireCheck, 5000);
    // 通知のON／OFF設定
    await this.postRequest('/idmgmt/getNotificationFlag', { companyID: this.companyID, userID: this.userID }).then(
      res => {
        if (res.data) {
          if (res.data.flag === null || typeof res.data.flag === 'undefined') {
            this.notificationFlag = null;
          } else {
            this.notificationFlag = res.data.flag;
          }
        } else {
          this.notificationFlag = null;
        }
      }
    );

    if (this.notificationFlag === null) {
      await this.postRequest('/idmgmt/setNotificationFlag', {
        companyID: this.companyID,
        userID: this.userID,
        data: {
          notificationFlag: true,
        },
      }).then(e => {
        if (e.status) {
          this.notificationFlag = true;
        }
      });
    }

    // 通知の許可設定
    if (this.notificationFlag === true) {
      this.checkNotificationPermission().then(result => {
        console.log(result);
      });
    }
  },
  methods: {
    ...mapActions(['updateOnlineStatus']),
    //Status
    handleOnlineStatusChange(onlineStatus) {
      this.updateAgentStatus(onlineStatus);
    },
    setLoading(value) {
      this.isLoading = !!value;
    },
    sessionAboutToExpireCheck() {
      const latestRequestTime = this.$store.state.latestRequestTime;
      if (!latestRequestTime) return;
      const sessionLifetime = this.$store.state.user.sessionLifetime;
      if (!sessionLifetime) return;

      const currentTime = new Date().getTime();
      const alertTimeInMs = (sessionLifetime - 1) * 60 * 60 * 1000;
      this.sessionAboutToExpire = currentTime - latestRequestTime >= alertTimeInMs;
    },
    handleLogout() {
      if (this.firebase && this.firebase.isInitial) this.firebase.signOut();
      this.isLoggedOut = true;
    },
    updateAgentStatus: function (agentStatus) {
      const self = this;
      this.postRequest('/clientUpdate', { agentStatus }).then(data => {
        if (data.status === 'success') {
          self.updateOnlineStatus(agentStatus);
        }
      });
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
    checkNotificationPermission: async function () {
      let permissionResult = '';
      await Notification.requestPermission()
        .then(permission => {
          if (permission === 'granted') {
            permissionResult = 'granted';
          } else if (permission === 'denied') {
            permissionResult = 'denied';
          } else if (permission === 'default') {
            permissionResult = 'default';
          } else {
            permissionResult = null;
          }
        })
        .catch(err => {
          console.error('Notification requestPermission error ' + err);
          permissionResult = null;
        });
      return permissionResult;
    },
  },
};
</script>
